import { hnAPI } from '../../constants/api';
import fetchApi from '../../services/fetch';
import {
  isMobile,
  removeWhiteSpace,
  convertGenderValue,
  getMonthInNumber,
  generateRandomAlphaNumeric,
} from '../../utils/utils';
import { get } from 'lodash';
import {
  track,
  updateGlobalTracker,
  generateServerResponseError,
  generateMessageDisplayedSegment,
} from 'utils/segmenTracker';
import { ACTIVATION, ORDER_FAILED, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED, ORDERSUCCESS } from 'constants/segmentEvents';
import { getDocumentTypeHN } from 'utils/hnUtils';

const activationParams = (params) => {
  const { pos_dmsid } = localStorage.getItem('auth') ? JSON.parse(atob(localStorage.getItem('auth'))) : {};
  return {
    folderName: params.folderName,
    activateService: {
      comments: '',
      waitForDownPayment: params.downPaymentStatus,
      scoreValidation: {
        hasDebt: '',
        qualificationScore: '',
      },
      payments: [
        {
          method: params.paymentMethod,
          amount: params.paymentPrice,
          currency: 'HNL',
          concept: 'installation',
          paymentsConditions : [{id : params.paymentCondition?.id}]
        },
      ],
      createCustomerMutation: {
        included: {
          newInstance: {
            attributes: {
              accountType: 'clientType',
            },
          },
        },
        individualsCreateMutation: {
          included: {
            newInstance: {
              attributes: {
                familyName: params.cliLastName,
                givenName: params.cliFirstName,
                gender: convertGenderValue(params.gender),
                dateOfBirth: `${params.birthYear}-${getMonthInNumber(params.birthMonth)}-${params.birthDate}`,
                nationality: 'HN',
                maritalStatus: '',
              },
              included: {
                identifications: {
                  attributes: {
                    identificationId: removeWhiteSpace(params.documentNumber),
                    identificationType: getDocumentTypeHN(params.documentType),
                    issuingAuthority: {
                      city: '',
                      stateOrProvince: '',
                      country: '',
                    },
                  },
                },
                contactMedia: params.residencyNumber
                  ? [
                      {
                        attributes: {
                          mediumType: 'emailAddress',
                          role: 'primary',
                          medium: {
                            emailAddress: {
                              email: params.email,
                            },
                          },
                        },
                      },
                      {
                        attributes: {
                          mediumType: 'telephoneNumber',
                          role: 'primary',
                          medium: {
                            telephoneNumber: {
                              number: removeWhiteSpace(params.cliTelephone),
                              numberType: 'mobile',
                            },
                          },
                        },
                      },
                      {
                        attributes: {
                          mediumType: 'telephoneNumber',
                          role: 'primary',
                          medium: {
                            telephoneNumber: {
                              number: params.residencyNumber ? removeWhiteSpace(params.residencyNumber) : '',
                              numberType: 'residential',
                            },
                          },
                        },
                      },
                    ]
                  : [
                      {
                        attributes: {
                          mediumType: 'emailAddress',
                          role: 'primary',
                          medium: {
                            emailAddress: {
                              email: params.email,
                            },
                          },
                        },
                      },
                      {
                        attributes: {
                          mediumType: 'telephoneNumber',
                          role: 'primary',
                          medium: {
                            telephoneNumber: {
                              number: removeWhiteSpace(params.cliTelephone),
                              numberType: 'mobile',
                            },
                          },
                        },
                      },
                    ],
              },
            },
          },
        },
        aditionalInformation: {
          employer: {
            name: '',
            position: '',
            phone: '',
            businessActivity: '',
          },
          references: [
            {
              name: params.refNameA,
              phone: removeWhiteSpace(params.refTelephoneA),
              relationtype: '',
            },
            {
              name: params.refNameB,
              phone: removeWhiteSpace(params.refTelephoneB),
              relationtype: '',
            },
          ],
        },
      },
      workOrder: {
        included: {
          newInstance: {
            attributes: {
              location: {
                id: params.coverage.id,
                reference: params.addressref || '',
                comments: '',
                attachment: {
                  description: '',
                  photo: '',
                },
                geolocation: {
                  latitude: `${get(params, 'location[0]', '')}`,
                  longitude: `${get(params, 'location[1]', '')}`,
                },
                node: {
                  node: params.coverage.node,
                },
                attributes: {
                  street: '',
                  neighborhood: params.suburb['description'],
                  city: params.city['MUNICIPIO'],
                  state: params.department['DEPARTAMENTO'],
                  country: 'Honduras',
                  postalCode: '',
                  houseNumber: '',
                },
              },
              dateTime: {
                start: '',
                end: '',
              },
            },
          },
        },
      },
      createBasketAndAddItemsMutation: {
        basketCreateMutation: {
          included: {
            newInstance: {
              attributes: {
                referenceNumber: `HN-${generateRandomAlphaNumeric(11)}`,
                salesContext: {
                  channel: 'string',
                  salespersonId: pos_dmsid,
                  salesType: 'assisted',
                },
              },
            },
          },
        },
        addBasketItemsMutation: [
          {
            included: {
              newInstance: {
                attributes: {
                  action: 'Add',
                  quantity: 1,
                },
                included: {
                  basketEntity: {
                    basketProducts: {
                      attributes: {
                        promoMSISDN: params.promoMSISDN || '',
                      },
                      relationships: {
                        productOfferingId: params.selectedPackage.prodId,
                      },
                    },
                  },
                },
                childBasketItems: params.selectedAddons.length
                  ? params.selectedAddons.map((addon) => ({
                      attributes: {
                        action: 'Add',
                        quantity: params.quantity[addon.prodId] || 1,
                      },
                      included: {
                        basketEntity: {
                          basketProducts: {
                            relationships: {
                              productOfferingId: addon.prodId,
                            },
                          },
                        },
                      },
                    }))
                  : [],
              },
            },
          },
        ],
      },
    },
  };
};

const initialState = {
  clientDetails: {
    isUpload: isMobile ? false : true,
  },
  orderStatus: {},
  finalStatus: {},
  paymentOption: "",
  tempPackages : null,
};

export const activation = {
  state: { ...initialState },
  reducers: {
    updateClientInformation(state, payload) {
      return {
        ...state,
        clientDetails: { ...state.clientDetails, ...payload },
      };
    },
    updateOrderStatus(state, payload) {
      return {
        ...state,
        orderStatus: { ...state.orderStatus, ...payload },
      };
    },
    updatefinalStatus(state, payload) {
      return {
        ...state,
        finalStatus: { ...state.finalStatus, ...payload },
      };
    },
    updatePaymentOption(state, payload) {
      return {
        ...state,
        paymentOption: payload,
      };
    },
    resetActivationStatus(state) {
      return {
        ...state,
        finalStatus: {},
        orderStatus: {},
      };
    },
    clearActivation() {
      return { ...initialState };
    },
    setTempPackage(state , payload){
      return  { ...state , tempPackages : payload}
    },
    cleaeTempPackage(state){
      return {...state , tempPackages : null}
    }

  },
  effects: (dispatch) => {
    return {
      async getOrderID({ callback, paymentOption, ...params }) {
        this.updatePaymentOption(paymentOption);
        dispatch.apiStatus.setProcessing(true);
        this.resetActivationStatus();  
        fetchApi({
          method: 'PUT',
          url: hnAPI.activation,
          data: { ...activationParams(params) },
        })
          .then((response) => {
            this.updateOrderStatus(response.data);
            const { response: orderStatusResponse } = response.data;
            updateGlobalTracker({ lead_id: orderStatusResponse.id });
            this.getOrderStatus({
              orderId: orderStatusResponse.id,
              callback,
            });
          })
          .catch((error) => {
            track(ORDER_FAILED, {
              journey: ACTIVATION,
              error_type: 'error',
              error_id: error.errorCode,
              error_message: error.message,
            });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(error, ACTIVATION, 'activation', hnAPI.activation, 'Get Order ID API'),
            });
            track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Get Order ID API') });
            dispatch.apiStatus.setRequestFailed({ ...error });
          });
      },
      async getOrderStatus({ callback, orderId, ...params }, state) {
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: 'GET',
          url: hnAPI.orders,
          params: { orderId },
        })
          .then((response) => {
            const counter = state.activation.finalStatus.counter || 0;
            this.updatefinalStatus({ ...response.data, counter: counter + 1 });
          })
          .catch((error) => {
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(error, ACTIVATION, 'activation', hnAPI.orders, 'Get Order Status API'),
            });
            track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Get Order Status API') });
            dispatch.apiStatus.setRequestFailed({ ...error });
          });
      },
      async callDAR({ darData, emailData, orderId, contractID }, state) {
        darData.accounts[0].billingAccountId = contractID;
        darData.externalAttributes[0].attrValues[0].attrValue = orderId;
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: 'post',
          url: hnAPI.callDar,
          data: { ...darData },
        })
          .then((response) => {
            if (state.activation.paymentOption === '2') { 
              this.sendEmailSms({ darResponse: response, ...emailData, });
            } else{
              dispatch.apiStatus.setProcessing(false);
            }
          })
          .catch((error) => {
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(error, ORDERSUCCESS, 'orderSuccess', hnAPI.callDar, 'DAR Api' )
            });
            track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ORDERSUCCESS, 'DAR Api') });
            dispatch.apiStatus.setRequestFailed({ ...error });
          });
      },
      async sendEmailSms({ darResponse, ...emailData }) {
        let reqPayload = emailData;
        reqPayload.customer_profile.tigoId = darResponse?.data?.body?.uuid;
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: 'post',
          url: hnAPI.emailSms,
          data: { ...reqPayload },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
          })
          .catch((error) => {
            dispatch.apiStatus.setRequestFailed({ ...error });
          });
      },
    };
  },
};
